import { CompanyRow, CompanyWithInvoiceCode } from '../types'

export const mapCompanyToRow = (
    company: CompanyWithInvoiceCode,
): CompanyRow => {
    const companyTypeStr =
        company.company_type === 'APARTMENT' ? 'Apartment' : 'Vendor'

    const billableUnitRate = Number(company.billable_unit_rate)
    const billableUnits = company.billable_unit_count
    const monthlyTotal = billableUnits * billableUnitRate

    return {
        id: { value: company.id, sortValue: company.id },
        name: { value: company.name, sortValue: company.name },
        organization: {
            value: company.organization.name,
            sortValue: company.organization.name,
        },
        address: {
            value: company.primary_address,
            sortValue: company.primary_address?.state ?? '',
        },
        status: {
            value: company.status,
            sortValue: company.status,
        },
        type: { value: companyTypeStr, sortValue: companyTypeStr ?? '' },
        invoice_code: {
            value: company.invoice_code,
            sortValue: company.invoice_code ?? '',
        },
        company: { value: company, sortValue: company.name },
        billable_units: { value: billableUnits, sortValue: billableUnits },
        billable_unit_rate: {
            value: billableUnitRate,
            sortValue: billableUnitRate,
        },
        monthly_total: { value: monthlyTotal, sortValue: monthlyTotal },
        billing_group_display_name: {
            value: company.billing_group?.name ?? '',
            sortValue: company.billing_group?.name ?? '',
        },
    }
}

export const SORT_KEY_TO_ORDERING: Partial<Record<keyof CompanyRow, string>> = {
    id: 'id',
    organization: 'organization',
    name: 'name',
    address: 'address',
    status: 'status',
    billable_units: 'billable_units',
    billable_unit_rate: 'billable_unit_rate',
}

export const toggleOrdering = (
    currentOrdering: string | undefined,
    sortKey: string,
): string => {
    const base = SORT_KEY_TO_ORDERING[sortKey as keyof CompanyRow] ?? sortKey
    if (currentOrdering === base) {
        return `-${base}`
    }
    return base
}
